export default "__VITE_ASSET__CfSc8v4D__"